import { render } from "./PageScroller.vue?vue&type=template&id=5b63c8ec"
import script from "./PageScroller.vue?vue&type=script&lang=js"
export * from "./PageScroller.vue?vue&type=script&lang=js"

import "./PageScroller.vue?vue&type=style&index=0&id=5b63c8ec&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__